/**
 * /join/$token — PUBLIC pre-boarding page for a new joiner (spec
 * docs/superpowers/specs/2026-11-02-checklists-preboarding.md §4, §10.2).
 *
 * Top-level (not under _auth / _authgated): no WorkRight sign-in, no app shell,
 * no auth redirect. It talks only to /api/v1/joiner/* through its own isolated
 * client (lib/api/joiner.ts).
 */
import { createFileRoute } from "@tanstack/react-router";
import { JoinPage } from "@/components/joiner/join-page";

export const Route = createFileRoute("/join/$token")({
  component: JoinRoute,
});

function JoinRoute() {
  const { token } = Route.useParams();
  return <JoinPage token={token} />;
}
